// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD5nn-NOzp-RVz0vb382Mh-fiFVjgyM0jw",
  authDomain: "revampspaces-53338.firebaseapp.com",
  projectId: "revampspaces-53338",
  storageBucket: "revampspaces-53338.firebasestorage.app",
  messagingSenderId: "597724076222",
  appId: "1:597724076222:web:d2a4030b9642d8531a66ef"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export default app;
